'use client';

import { Box } from '@terra/ui-styled-system';
import {
  FindingCvssTab,
  Scroll,
  Tabs,
  type FindingCvssTabProps,
} from '@terra/ui-design-system';
import { useFeatureFlagsContext } from '../../app/providers/FeatureFlagsProvider';
import { useApplicationById } from '../../hooks/api/useApplicationById';
import { useAppTargetId } from '../../store/projectStore';

export function FindingCvssTabPanel({
  finding,
}: Pick<FindingCvssTabProps, 'finding'>) {
  const { featureFlags } = useFeatureFlagsContext();
  const isEnabled = featureFlags.FINDING_CVSS_DETAILS_TAB_ENABLED === true;
  const appTargetId = useAppTargetId();
  const { application } = useApplicationById({
    id: appTargetId,
    enabled: isEnabled,
  });

  if (!isEnabled) {
    return null;
  }

  return (
    <Tabs.Content value="cvss" flex="1" overflow="hidden" pt="0">
      <Box h="full" overflow="hidden">
        <Scroll orientation="vertical" showScrollbar>
          <Box p="4">
            <FindingCvssTab
              finding={finding}
              applicationCvssVersion={
                application?.cvssVersion === 'V3_1'
                  ? '3.1'
                  : application?.cvssVersion === 'V4_0'
                    ? '4.0'
                    : null
              }
              environmentalRequirements={
                application?.cvssEnvironmentalRequirements
              }
            />
          </Box>
        </Scroll>
      </Box>
    </Tabs.Content>
  );
}
